import {Link} from 'react-router-dom'
import { Button } from 'antd'
import {loginSelector} from '../../api/authSlice'
import { fetchAllJob,JobSelector } from '../../api/jobs'
import {useDispatch, useSelector} from 'react-redux'
import DataTable from './datatable'
import { useEffect,useState } from 'react'


export default function Jobs(){

    const dispatch = useDispatch()
    const {jobs} = useSelector(JobSelector)
    const {filter} = useSelector(loginSelector)
    const [loading, setLoading] = useState(false)

    useEffect(()=>{
        dispatch(fetchAllJob())
        }, [dispatch])

    return (
        <>
<div className="mb-4 float-right ">
    <div className="mx-3">

{/* <Search placeholder="Search Blog" className="mx-3" style={{ width: 230 }} enterButton /> */}
    <Button type="primary">
        <Link className=' text-white' to="/admin/create-job">Add Job</Link>
    </Button> 
</div>
</div>
{

 <DataTable loading={loading}
 data ={(filter.length> 0) ? filter : jobs}/>

}
    </>
    )
}